<template>
  <div class="wrapper">
    <side-bar> </side-bar>
    <div class="main-panel ps-container">
      <!-- Navbar -->
      <nav
        class="navbar navbar-expand-lg navbar-absolute fixed-top navbar-transparent"
      >
        <div class="container-fluid">
          <div class="navbar-wrapper">
            <div class="navbar-minimize">
              <button id="minimizeSidebar" class="btn btn-icon btn-round">
                <i
                  class="nc-icon nc-minimal-right text-center visible-on-sidebar-mini"
                ></i>
                <i
                  class="nc-icon nc-minimal-left text-center visible-on-sidebar-regular"
                ></i>
              </button>
            </div>
            <div class="navbar-toggle">
              <button type="button" class="navbar-toggler">
                <span class="navbar-toggler-bar bar1"></span>
                <span class="navbar-toggler-bar bar2"></span>
                <span class="navbar-toggler-bar bar3"></span>
              </button>
            </div>
            <a class="navbar-brand" href="#pablo">{{ title }}</a>
          </div>
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navigation"
            aria-controls="navigation-index"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-bar navbar-kebab"></span>
            <span class="navbar-toggler-bar navbar-kebab"></span>
            <span class="navbar-toggler-bar navbar-kebab"></span>
          </button>
          <div
            class="collapse navbar-collapse justify-content-end"
            id="navigation"
          >
            <!--<form>
                            <div class="input-group no-border">
                                <input type="text" value="" class="form-control" placeholder="Search...">
                                <div class="input-group-append">
                                    <div class="input-group-text">
                                        <i class="nc-icon nc-zoom-split"></i>
                                    </div>
                                </div>
                            </div>
                        </form>-->
            <ul class="navbar-nav">
              <!--<li class="nav-item">
                                <a class="nav-link btn-magnify" href="#pablo">
                                    <i class="nc-icon nc-layout-11"></i>
                                    <p>
                                        <span class="d-lg-none d-md-block">Stats</span>
                                    </p>
                                </a>
                            </li>-->
              <li class="nav-item btn-rotate dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  href=""
                  id="navbarDropdownMenuLink"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  placeholder="Change language"
                >
                  <i class="nc-icon nc-globe-2"></i>
                  <p>
                    <span class="d-lg-none d-md-block">Some Actions</span>
                  </p>
                </a>
                <div
                  class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="navbarDropdownMenuLink"
                >
                  <!-- <a class="dropdown-item" href="#" @click="changeLanguage('ua')">UA</a>
                                    <a class="dropdown-item" href="#" @click="changeLanguage('en')">EN</a>
                                    <a class="dropdown-item" href="#" @click="changeLanguage('ru')">RU</a> -->
                  <a
                    class="dropdown-item"
                    :id="item.lang"
                    v-for="item in listLanguages"
                    :key="item.id"
                    @click="changeLanguage(item.lang)"
                  >
                    <i
                      class="flag-icon"
                      :class="$i18n.getLocaleMessage(item.lang).lang.logo"
                    ></i>
                    {{ $i18n.getLocaleMessage(item.lang).lang.title }}
                  </a>
                </div>
              </li>
              <li class="nav-item">
                <a class="nav-link btn-rotate" href="#pablo">
                  <i class="nc-icon nc-settings-gear-65"></i>
                  <p>
                    <span class="d-lg-none d-md-block">Account</span>
                  </p>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <router-view />
      <footer class="footer footer-black footer-white">
        <div class="container-fluid">
          <div class="row">
            <nav class="footer-nav">
              <ul>
                <li>
                  <a href="https://www.modern-expo.com/" target="_blank"
                    >Moder-Expo site</a
                  >
                </li>
                <li>
                  <a
                    href="https://www.modern-expo.com/uk/products"
                    target="_blank"
                    >Products</a
                  >
                </li>
                <li>
                  <a
                    href="https://www.modern-expo.com/uk/policy"
                    target="_blank"
                    >Policy</a
                  >
                </li>
              </ul>
            </nav>
            <div class="credits ml-auto">
              <span class="copyright">
                © {{ year }} made with <i class="fa fa-heart heart"></i> by
                Modern-Expo IT TEAM
              </span>
            </div>
          </div>
        </div>
      </footer>
      <notifications group="error" classes="alert alert-danger" />
      <notifications group="info" classes="alert alert-info" />
      <notifications group="success" classes="alert alert-success" />
    </div>
  </div>
</template>

<script>
export default {
  name: "DashboardLayout",
  components: {},
  data() {
    return {
      loading: false,
      title: "",
      year: 0,
    };
  },
  mounted() {
    let y = new Date();
    this.year = y.getFullYear();

    (function () {
      let isWindows = navigator.platform.indexOf("Win") > -1 ? true : false;
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        $(".sidebar .sidebar-wrapper, .main-panel").perfectScrollbar();

        $("html").addClass("perfect-scrollbar-on");
      } else {
        $("html").addClass("perfect-scrollbar-off");
      }
    })();
    document
      .getElementById("minimizeSidebar")
      .addEventListener("click", this.minimize, false);
  },

  created() {
    this.title = this.$route.meta.title;
  },

  beforeRouteUpdate(to, from, next) {
    this.title = to.meta.title;
    next();
  },

  destroyed() {
    //  document.getElementById('minimizeSidebar').removeEventListener('click', this.minimize, false)
  },

  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimize() {
      if (!document.body.classList.contains("sidebar-mini")) {
        document.body.classList.add("sidebar-mini");
      } else {
        document.body.classList.remove("sidebar-mini");
      }
    },

    changeLanguage(len) {
      this.$i18n.locale = len;
    },
  },
  computed: {
    listLanguages() {
      let arrLang = [];
      for (let i = 0; i < this.$i18n.availableLocales.length; i++) {
        arrLang.push({
          id: this.$i18n.getLocaleMessage(this.$i18n.availableLocales[i]).lang
            .id,
          lang: this.$i18n.availableLocales[i],
        });
      }
      arrLang.sort(function (obj1, obj2) {
        return obj1.id - obj2.id;
      });
      return arrLang;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/layout/dashboard/DashboardLayout.vue